import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { IconReviewStar, Reviews } from '../../components';
import css from './ListingPage.css';

const SectionReviews = props => {
  const { rating, reviews, fetchReviewsError } = props;

  const reviewsError = (
    <h2 className={css.errorText}>
      <FormattedMessage id="ListingPage.reviewsError" />
    </h2>
  );
  const totalReviews = reviews.length;

  return (
    <div className={css.sectionReviews}>
      <div className={css.reviewsHeadingContainer}>
        {totalReviews < 3 ? (
          <h2 className={css.reviewsHeadingVariant}>
            <FormattedMessage id="ListingPage.reviewsHeadingVariant" values={{ count: totalReviews }} />
          </h2>
        ) : (
          <Fragment>
            <IconReviewStar className={css.iconReviewStar} isFilled />
            <h2 className={css.reviewsHeading}>
              <FormattedMessage id="ListingPage.reviewsHeading" values={{ rating: rating, count: totalReviews }} />
            </h2>
          </Fragment>
        )}
      </div>
      {fetchReviewsError ? reviewsError : null}
      <Reviews className={css.reviewsContainer} reviewItemClassName={css.reviewItem} reviews={reviews} />
    </div>
  );
};

export default SectionReviews;



// WEBPACK FOOTER //
// ./src/containers/ListingPage/SectionReviews.js